export var MeasurementsTypes;
(function (MeasurementsTypes) {
    function isObject(input) {
        return typeof input === "object" && input !== null;
    }
    MeasurementsTypes.isObject = isObject;
    function isResponse(input) {
        const _input = input;
        return (isObject(_input) &&
            _input.code !== undefined &&
            typeof _input.id === "string");
    }
    MeasurementsTypes.isResponse = isResponse;
    function isErrorResponse(input) {
        var _a, _b;
        const _input = input;
        return (isObject(_input) &&
            ((_a = _input.data) === null || _a === void 0 ? void 0 : _a.error) &&
            typeof ((_b = _input.data) === null || _b === void 0 ? void 0 : _b.error.message) === "string");
    }
    MeasurementsTypes.isErrorResponse = isErrorResponse;
    function isDataResponse(input) {
        var _a, _b;
        const _input = input;
        return (isObject(_input) &&
            typeof ((_a = _input.data) === null || _a === void 0 ? void 0 : _a.measurements) === "object" &&
            typeof ((_b = _input.data) === null || _b === void 0 ? void 0 : _b.file) === "string");
    }
    MeasurementsTypes.isDataResponse = isDataResponse;
    function isLayoutResponse(input) {
        const _input = input;
        return isObject(_input) && typeof _input.overlayData === "object";
    }
    MeasurementsTypes.isLayoutResponse = isLayoutResponse;
    function isMetadataResponseGroup(input) {
        const _input = input;
        return (isObject(_input) &&
            _input.type === "group" &&
            Array.isArray(_input.children));
    }
    MeasurementsTypes.isMetadataResponseGroup = isMetadataResponseGroup;
    function isMetadataResponseMeasurement(input) {
        const _input = input;
        return isObject(_input) && _input.type === "measurement";
    }
    MeasurementsTypes.isMetadataResponseMeasurement = isMetadataResponseMeasurement;
    function isMetadataResponseNode(input) {
        return (isMetadataResponseGroup(input) || isMetadataResponseMeasurement(input));
    }
    MeasurementsTypes.isMetadataResponseNode = isMetadataResponseNode;
})(MeasurementsTypes || (MeasurementsTypes = {}));
//# sourceMappingURL=types.js.map